/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateOrganisationRequest
 */
export interface UpdateOrganisationRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    fullName?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateOrganisationRequest
     */
    rowSequence?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateOrganisationRequest
     */
    externalMaintenanceTicketingName?: string;
    /**
     * The max number of devices that users in this org can create.
     * @type {number}
     * @memberof UpdateOrganisationRequest
     */
    deviceProvisioningLimit?: number;
    /**
     * Updated group ids for the org
     * @type {Array<string>}
     * @memberof UpdateOrganisationRequest
     */
    organisationGroupIds?: Array<string>;
}

/**
 * Check if a given object implements the UpdateOrganisationRequest interface.
 */
export function instanceOfUpdateOrganisationRequest(
    value: object,
): value is UpdateOrganisationRequest {
    return true;
}

export function UpdateOrganisationRequestFromJSON(
    json: any,
): UpdateOrganisationRequest {
    return UpdateOrganisationRequestFromJSONTyped(json, false);
}

export function UpdateOrganisationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateOrganisationRequest {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        fullName: json["fullName"] == null ? undefined : json["fullName"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
        externalMaintenanceTicketingName:
            json["externalMaintenanceTicketingName"] == null
                ? undefined
                : json["externalMaintenanceTicketingName"],
        deviceProvisioningLimit:
            json["deviceProvisioningLimit"] == null
                ? undefined
                : json["deviceProvisioningLimit"],
        organisationGroupIds:
            json["organisationGroupIds"] == null
                ? undefined
                : json["organisationGroupIds"],
    };
}

export function UpdateOrganisationRequestToJSON(
    value?: UpdateOrganisationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        fullName: value["fullName"],
        rowSequence: value["rowSequence"],
        externalMaintenanceTicketingName:
            value["externalMaintenanceTicketingName"],
        deviceProvisioningLimit: value["deviceProvisioningLimit"],
        organisationGroupIds: value["organisationGroupIds"],
    };
}
